import { AppError } from "./AppError";

export class ForbiddenError extends AppError {
  status: number;

  constructor(
    message: string = "You do not have permission to view this page.",
  ) {
    super(message);
    this.name = "ForbiddenError";
    this.status = 403;
    Object.setPrototypeOf(this, ForbiddenError.prototype);
  }
}
